module.exports = __webpack_public_path__ + "img/logmanagement.84e0d829.svg";